import classNames, { type Argument } from "classnames";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge our custom typography scale (from tokens.json) so a
// font-size utility (text-caption, text-heading, …) is never conflated with a
// text-color utility (text-on-navy, text-text, …) and silently dropped.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display",
            "title",
            "heading",
            "body-lg",
            "body",
            "label",
            "caption",
          ],
        },
      ],
    },
  },
});

export function cn(...args: Argument[]): string {
  return twMerge(classNames(...args));
}
